
import { login } from '@/services/endpoints/auth'
import router from '@/router'
import { changePassword } from '@/services/endpoints/users';

export default {

  async login({ commit }, payload) {
    // return new Promise((resolve, reject) => {
    try {
      let res = await login(payload);
      if(res.data.access_token) {
        commit('SET_TOKEN', res.data.access_token);
        // commit('SET_USER', res.data.user);
        commit('SET_ABILITY', res.data);
        commit('LOGIN_SUCCESS', res.data.user);
        // commit('SET_USER', res.data.user)
        // localStorage.setItem("user", JSON.stringify(res.data.user));
        return res.data
      }
    }
    catch (err) {
      // if (err.response.status === 401) {
      //   vm.$bvToast.toast(i18n.t('toastification.errorOccurred'), {
      //   title: i18n.t('toastification.usernameOrPasswordIsWrong'),
      //   variant: "danger",
      //   solid: true,
      // })
      // }
      
      throw(err)
    }
  },
  logout(state) {
    return new Promise(resolve => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      state.token = null;
      state.user = null;
      resolve()
    })
    // cookie.remove("token");
    // cookie.remove("user");

    // router.push({name:'login'})
  },
  async changePassword({ commit }, payload) {
    // return new Promise((resolve, reject) => {
    try {
      let res = await changePassword(payload);
      if (res.data) {
        return res.data
      }
    }
    catch (err) {
      throw new Error(err)
    }
  },
}
